(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/match-list-header.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/match-list-header.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.MatchListHeader = Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.match_list_header(data);
    },
    className: 'maltipset-matches-left',
    modelEvents: {
      'change:matchesLeftToSelect change:activeRowNum': 'render'
    }
  });
})(Backbone, _, svs);


 })(window);